<div class="gp-card-shell password-card">
  <div class="gp-card-header">
    <div class="gp-card-icon"><i class="pi pi-shield"></i></div>
    <div class="gp-card-title-wrap">
      <h3 class="gp-card-title">Password &amp; security</h3>
      <p class="gp-card-subtitle">{{ lastUpdatedText }}</p>
    </div>
  </div>

  <form [formGroup]="updatePasswordForm" (ngSubmit)="onSubmit()" class="password-form">

    <div class="form-section">
      <!-- Current & New Password -->
      <div class="form-row two-col">
        <div class="form-field">
          <label>Current password</label>
          <p-password formControlName="oldPassword" [toggleMask]="true" placeholder="Enter current password" [feedback]="false"></p-password>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.get('oldPassword')?.errors?.['required']">
            Current password is required
          </div>
          <div class="error-msg" *ngIf="currentPasswordError">
            {{ currentPasswordError }}
          </div>
        </div>

        <div class="form-field">
          <label>New password</label>
          <p-password formControlName="newPassword" [toggleMask]="true" placeholder="Enter new password" [feedback]="false"></p-password>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.get('newPassword')?.errors?.['required']">
            New password is required
          </div>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.get('newPassword')?.errors?.['uppercase']">
            Must contain at least 1 uppercase letter
          </div>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.get('newPassword')?.errors?.['lowercase']">
            Must contain at least 1 lowercase letter
          </div>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.get('newPassword')?.errors?.['digit']">
            Must contain at least 1 number
          </div>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.get('newPassword')?.errors?.['specialChar']">
            Must contain at least 1 special character
          </div>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.get('newPassword')?.errors?.['length']">
            Must be at least 8 characters long
          </div>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="form-row single-col">
        <div class="form-field">
          <label>Confirm new password</label>
          <p-password formControlName="confirmPassword" [toggleMask]="true" placeholder="Confirm new password" [feedback]="false"></p-password>
          <div class="error-msg" *ngIf="submitted && updatePasswordForm.hasError('passwordMismatch')">
            Passwords do not match
          </div>
        </div>
      </div>

      <!-- Strength Bar -->
      <div class="strength-bar-container">
        <div class="segments">
          <div class="segment active"></div>
          <div class="segment active"></div>
          <div class="segment active"></div>
          <div class="segment"></div>
        </div>
        <div class="strength-label">&mdash; Medium</div>
      </div>
    </div>

    <div class="form-actions">
      <button type="submit" class="submit-btn" [disabled]="loading">
        {{ loading ? 'Updating...' : 'Update password' }}
      </button>
    </div>
  </form>
</div>
